module.exports = {

    init: function () {
        
        // console.log('DateFieldPlaceholder is working...');
        
        jQuery(document).on('change', '[data-hapiform-date-field]', function(e) {
            e.preventDefault();
            var $this = this;
            console.log(jQuery($this).val());

            if(jQuery($this).val() != '') {
                jQuery($this).addClass('has-value');
            } else {
                jQuery($this).removeClass('has-value');
            }
        });
        
    }

};